import { DateTime } from 'luxon';
import * as models from 'smg/customer-api/models';
import { Orders } from 'smg/customer-api/orders';
import * as session from 'smg/customer-api/session';
import * as shippingoptions from 'smg/customer-api/shippingoptions';
import { Human } from 'smg/phone';
import { AccountReady } from '../account-session';
import { Relref } from '../hugo';

void main();

async function main() {
    const $spinner = document.querySelector('#overview-spinner') as HTMLElement;
    const $content = document.querySelector('#overview-container') as HTMLElement;

    if (await AccountReady) {
        return;
    }

    const sess = session.Session();

    await Orders({
        sort: 'created desc',
        max: 1,
        data: 'invoiceNumber,created,orderPayments,orderProofs,key',
    }).then(data => {
        const latestOrder = data.results[0];

        if (!latestOrder) {
            const hasLatestOrder = document.querySelector('#has-latest-order') as HTMLElement;
            const noLatestOrder = document.querySelector('#no-latest-order') as HTMLElement;

            hasLatestOrder.classList.add('d-none');
            noLatestOrder.classList.remove('d-none');
            return;
        }

        if (latestOrder.invoiceNumber) {
            const orderNumber = document.querySelector('#order-number') as HTMLElement;
            orderNumber.textContent = latestOrder.invoiceNumber.toString();
        }

        if (latestOrder.created.isValid) {
            const orderDate = document.querySelector('#order-date') as HTMLElement;
            orderDate.textContent = latestOrder.created.toLocaleString(DateTime.DATE_SHORT);
        }

        if (latestOrder.orderPayments.length) {
            const orderPaymentMethod = document.querySelector('#order-payment-method') as HTMLElement;
            if (latestOrder.orderPayments.length > 1) {
                orderPaymentMethod.textContent = 'Multiple Methods';
            } else {
                const singleOrderPaymentOption = latestOrder.orderPayments[0].paymentOption;
                const bankOrCredit = singleOrderPaymentOption?.paymentOptionType?.id === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BANK ||
                    singleOrderPaymentOption?.paymentOptionType?.id === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT;
                orderPaymentMethod.textContent = bankOrCredit ?
                    `${singleOrderPaymentOption?.paymentOptionType?.name || ''} ending in ${singleOrderPaymentOption.creditCardLast4 || '****'}` :
                    singleOrderPaymentOption?.paymentOptionType?.name || '';
            }
        }

        const proofImgTag = document.querySelector('#latest-order-thumbnail') as HTMLImageElement;
        const proofAnchorTag = document.querySelector('#latest-proof-anchor') as HTMLAnchorElement;
        if (latestOrder.orderProofs.length) {
            const latestOrderProof = latestOrder.orderProofs[0];
            if (latestOrderProof) {
                if (latestOrderProof.proof?.main) {
                    proofAnchorTag.href = latestOrderProof.proof.main;
                }
                if (latestOrderProof.proof?.name) {
                    proofAnchorTag.dataset.caption = `Proof ${latestOrderProof.proof.name}`;
                }
                if (latestOrderProof.proof?.thumbnail) {
                    proofImgTag.src = latestOrderProof.proof.thumbnail;
                }
            }
        }

        const viewOrderDetailsBtn = document.querySelector('#view-order-details-btn') as HTMLButtonElement;
        viewOrderDetailsBtn.addEventListener('click', () => {
            window.location.href = `${Relref('/orders/track')}?id=${latestOrder.key}`;
        });
    });

    const name = document.querySelector('#user-first-name') as HTMLElement;
    name.textContent = (await sess).user.firstName ?? '';

    const profileName = document.querySelector('#user-name') as HTMLElement;
    const profileEmail = document.querySelector('#user-email') as HTMLElement;
    profileName.textContent = (await sess).user.fullName();
    profileEmail.textContent = (await sess).user.emailAddress.email;

    if ((await sess).user.phoneNumber.phone) {
        const profilePhone = document.querySelector('#user-phone') as HTMLElement;
        profilePhone.classList.remove('d-none');
        const p = Human((await sess).user.phoneNumber.phone);
        profilePhone.textContent = p;
    }

    if ((await sess).user.company) {
        const profileCompany = document.querySelector('#user-company') as HTMLElement;
        profileCompany.classList.remove('d-none');
        profileCompany.textContent = (await sess).user.company ?? '';
    }

    const $latestShippingContainer = document.querySelector('#latest-shipping-address-container') as HTMLElement;

    const { shippingOptions } = await shippingoptions.ShippingOptions({
        'data': 'address',
        'sort': 'created desc',
        'max': '1',
        'q': 'has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip',
    });

    if (!shippingOptions[0]) {
        $latestShippingContainer.classList.add('d-none');
        if ($latestShippingContainer.nextElementSibling instanceof HTMLHRElement) {
            $latestShippingContainer.nextElementSibling.classList.add('d-none');
        }
    } else {
        $latestShippingContainer.classList.remove('d-none');
        if ($latestShippingContainer.nextElementSibling instanceof HTMLHRElement) {
            $latestShippingContainer.nextElementSibling.classList.remove('d-none');
        }

        const $latestShippingInnerContainer = $latestShippingContainer.querySelector('#latest-shipping-address') as HTMLElement;
        const shippingAddress = shippingOptions[0].address;
        if (!shippingAddress) {
            $spinner.classList.add('d-none');
            $content.classList.remove('d-none');
            return;
        }

        const $shippingAddressLine = $latestShippingInnerContainer.querySelector('#address-line') as HTMLElement;
        $shippingAddressLine.textContent = shippingAddress.addressLine1 ?? '';
        const $shippingCity = $latestShippingInnerContainer.querySelector('#city') as HTMLElement;
        $shippingCity.textContent = shippingAddress.city ? `${shippingAddress.city},` : '';
        const $shippingState = $latestShippingInnerContainer.querySelector('#state') as HTMLElement;
        $shippingState.textContent = shippingAddress.state?.name ? `${shippingAddress.state.name},` : '';
        const $shippingZip = $latestShippingInnerContainer.querySelector('#zip') as HTMLElement;
        $shippingZip.textContent = shippingAddress.postalCode || '';
        const $shippingCountry = $latestShippingInnerContainer.querySelector('#country') as HTMLElement;
        $shippingCountry.textContent = shippingAddress.country?.name ?? '';
    }

    $spinner.classList.add('d-none');
    $content.classList.remove('d-none');
}
